import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class ContactFormSection extends Section {
  init() {
    on(this.refs.form, 'submit', (e) => {
      e.preventDefault()
      grecaptcha.ready(() => {
        grecaptcha.execute(window.__recaptchaSiteKey, { action: 'submit' }).then((token) => {
          this.refs.token.value = token
          this.refs.form.submit()
        });
      })
    })
  }
} 

register('contactform', ContactFormSection)
